import React, { useState, useEffect } from 'react';
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface CookieConsentBannerProps {
  onAccept: () => void;
  onSettings: () => void;
}

const CookieConsentBanner = ({ onAccept, onSettings }: CookieConsentBannerProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent-accepted', 'true');
    setIsVisible(false);
    setTimeout(onAccept, 300);
  };

  return (
    <div 
      className={`fixed bottom-0 left-0 right-0 z-50 transform transition-transform duration-300 ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="bg-background/95 backdrop-blur-sm border-t border-border">
        <div className="container mx-auto px-4 py-3">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <div className="flex-1 text-sm text-muted-foreground">
              <p>
                Usamos cookies para melhorar sua experiência. Ao continuar, você concorda com nossa{' '}
                <button 
                  onClick={onSettings}
                  className="text-primary hover:underline font-medium"
                >
                  Política de Privacidade
                </button>
                {' '}e o tratamento de dados conforme a LGPD.
              </p>
            </div>
            <div className="flex items-center gap-2">
              <Button 
                variant="outline" 
                size="sm" 
                onClick={onSettings}
                className="whitespace-nowrap"
              >
                Configurações
              </Button>
              <Button 
                size="sm" 
                onClick={handleAccept}
                className="whitespace-nowrap"
              >
                Aceitar
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;